export default {
  documento: {
    value: '',
    maxlength: '30',
    required: true,
    state: null
  },
  name: {
    value: null,
    listOptions: [],
    selected: null,
    required: true,
    state: null
  },
  email: {
    value: '',
    maxlength: '50',
    required: false,
    state: null
  },
  telefone: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  },
  celular: {
    value: '',
    maxlength: '15',
    required: false,
    state: null
  },
  leadOriginID: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/new/newlead-form.js